import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../../../lib/api-client';
import type {
  CreateProjectInput,
  Paginated,
  Project,
  UpdateProjectInput,
} from '../../../types/admin';
import { useClaveInmobiliaria } from '../inmobiliaria-activa/inmobiliaria-activa';

export function useProjects(page: number, pageSize: number) {
  // fix-60: la clave incluye la inmobiliaria activa (el superadmin puede cambiarla).
  const inmobiliaria = useClaveInmobiliaria();
  return useQuery<Paginated<Project>>({
    queryKey: ['projects', inmobiliaria, page, pageSize],
    queryFn: () => apiClient.projects.list({ page, pageSize }),
  });
}

function invalidateProjects(queryClient: ReturnType<typeof useQueryClient>): void {
  void queryClient.invalidateQueries({ queryKey: ['projects'] });
}

export function useCreateProject() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: CreateProjectInput) => apiClient.projects.create(data),
    onSuccess: () => invalidateProjects(queryClient),
  });
}

export function useUpdateProject() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateProjectInput }) =>
      apiClient.projects.update(id, data),
    onSuccess: () => invalidateProjects(queryClient),
  });
}

/** change-70: cierre de un proyecto ACTIVO (`POST /projects/:id/close`). */
export function useCloseProject() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => apiClient.projects.close(id),
    onSuccess: () => invalidateProjects(queryClient),
  });
}

export function useDeactivateProject() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => apiClient.projects.deactivate(id),
    onSuccess: () => invalidateProjects(queryClient),
  });
}
